import { Stack, Typography, Link as MuiLink, Divider, Box, Breadcrumbs, Paper, Button } from '@mui/material';
import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home as HomeIcon, Business as BusinessIcon, Upload as UploadIcon } from '@mui/icons-material';
import MainCard from 'ui-component/cards/MainCard';

// ==============================|| LEADGEN LAYOUT ||============================== //

function LeadGenLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const isImportPage = location.pathname.includes('/import');

    return (
        <Box sx={{ ml: 2 }}>
            {!isImportPage && (
                <Paper
                    elevation={0}
                    sx={{
                        p: 2,
                        mb: 2,
                        bgcolor: 'background.default',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Breadcrumbs aria-label='breadcrumb' sx={{ mb: 1 }}>
                        <MuiLink
                            component={Link}
                            to={`/${location.pathname.split('/')[1]}/leadgeneration`}
                            sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                            color='inherit'
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize='inherit' />
                            Lead Generation
                        </MuiLink>
                        {location.pathname.includes('/import') && (
                            <Typography color='text.primary' sx={{ display: 'flex', alignItems: 'center' }}>
                                <UploadIcon sx={{ mr: 0.5 }} fontSize='inherit' />
                                Import
                            </Typography>
                        )}
                    </Breadcrumbs>
                </Paper>
            )}
            <Outlet />
        </Box>
    );
}

export default LeadGenLayout;
